export default "__VITE_ASSET__DYKXn5JY__"